import { ReactNode } from 'react';
import { Button, Flex, Heading, Stack, StackProps } from '@chakra-ui/react';

export interface InfoBlockProps extends StackProps {
  children: ReactNode;
  variant?: 'spacing' | 'center';
}

export function InfoBlock(props: InfoBlockProps) {
  const { children, variant = 'spacing', ...stackProps } = props;

  return (
    <Stack
      direction={variant === 'spacing' ? 'column' : 'row'}
      justifyContent={variant === 'center' && 'space-around'}
      alignItems="center"
      border="1px"
      borderRadius="24px"
      layerStyle="layer3"
      borderColor="gray.200"
      spacing={stackProps.spacing || 3}
      p={stackProps.p || 4}
      {...stackProps}
    >
      {children}
    </Stack>
  );
}

export function InfoBlockHeader(props: {
  title: string;
  description?: string;
  onEditClick?: () => void;
  isMe?: boolean;
}) {
  return (
    <Flex w="100%" justifyContent="space-between">
      <Heading
        as="h5"
        textStyle="h5"
        fontWeight="700"
        lineHeight="18px"
        fontSize="sm"
        noOfLines={2}
      >
        <div>{props.title}</div>
        {props.description && (
          <div className="mt-3 text-sm font-normal border border-gray-500 text-gray-500 rounded-full px-2 w-min ">
            {props.description}
          </div>
        )}
      </Heading>
      {props.onEditClick && props.isMe && (
        <Button
          style={{ height: 'fit-content' }}
          textStyle="buttonText"
          variant="link"
          onClick={props.onEditClick}
          fontWeight="400"
        >
          Edit
        </Button>
      )}
    </Flex>
  );
}
